export const formBaseUrl = 'https://www.tfaforms.com/5182586'
export const clusterList = {
	Mumbai: 'tfa_27424',
	Bengaluru: 'tfa_27947',
	Chennai: 'tfa_27999',
	Delhi: 'tfa_27915',
	Ahmedabad: 'tfa_27965',
	Hyderabad: 'tfa_28011',
	Pune: 'tfa_28021',
	Kolkata: 'tfa_32710',
}

export const keyMapping = {
	applicantID: 'tfa_99',
	city: 'tfa_91',
	cluster: 'tfa_3',
	availability: 'tfa_5',
}

/**
 * Generates a parameterised FormAssembly URL
 * @param {object} params the parameters to pass in the URL
 * @param {string} params.mode
 * @param {string} params.city
 * @param {string} params.subject1
 * @param {string} params.subject2
 * @param {string} params.ref_code
 * @param {string} params.availability
 * @param {string} params.cluster
 * @returns {string} Parameterised FormAssembly URL
 */
export default function getFormUrl(params) {
	let formUrl = `${formBaseUrl}`
	let validParams = Object.entries(params).filter(([key, value]) => {
		if (value && keyMapping[key]) {
			return true
		} else {
			return false
		}
	})
	if (validParams.length > 1) {
		formUrl += '?'
		validParams.forEach(([key, value], index) => {
			if (index !== 0) {
				formUrl += '&'
			}
			formUrl += `${keyMapping[key]}=${value}`
		})
	}
	return formUrl
}
